import * as React from "react";
function InformationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21c-4.963 0-9-4.038-9-9 0-4.963 4.037-9 9-9 4.962 0 9 4.037 9 9 0 4.962-4.038 9-9 9zm0-17.217c-4.531 0-8.217 3.686-8.217 8.217 0 4.531 3.686 8.217 8.217 8.217 4.531 0 8.217-3.686 8.217-8.217 0-4.531-3.686-8.217-8.217-8.217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.783 16.308a1.175 1.175 0 01-1.174-1.174v-5.087h-1.174a.391.391 0 010-.783h1.174c.43 0 .782.351.782.783v5.087c0 .216.176.39.392.39h1.174a.391.391 0 010 .784h-1.174zM11.8 8.477a.587.587 0 11.001-1.174.587.587 0 010 1.174z"
  }));
}
const ForwardRef = React.forwardRef(InformationIcon);
export default ForwardRef;